
import { Component, Vue } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import BaseCampos from '@/components/base/BaseCampos.vue';
import DatePicker from '@/components/base/DatePicker.vue';
import TimePicker from '@/components/base/TimePicker.vue';
// Services
import NotificacaoService from '@/services/notificacao.service';
// Models
import { NotificacaoInterface } from '@/shared/models/notificacao/notificacao.interface';

import { BaseDialogInterface } from '@/shared/models/base/dialog.interface';
// UTILS
import Rules from '@/shared/utils/rules.util';
import { NotificacaoFilter } from '@/shared/models/notificacao/notificacao.filter';
import DDDService from '@/services/ddd.service';
import { DDDInterface } from '@/shared/models/ddd/ddd.interface';

@Component({
  components: {
    BasePagina,
    BaseDialog,
    BasePesquisa,
    BaseCampos,
    DatePicker,
    TimePicker,
  },
})
export default class Notificacao extends Vue {
  private rules = Rules;

  public labelBotaoNovo = 'Nova Notificação';

  public editedItem = { tipoNotificacao: 'NOTIFICACAO_GERAL' } as NotificacaoInterface;

  public loading = true;

  public filtro = {} as NotificacaoFilter;

  public listaDDD: Array<DDDInterface> = [];

  public listaCidades: Array<DDDInterface> = [];

  public listaEstados: Array<DDDInterface> = [];

  public notificacaoRecorrente = false;

  private NOTIFICACAO_GERAL = 'NOTIFICACAO_GERAL';

  private NOTIFICACAO_PARA_CIDADE = 'NOTIFICACAO_PARA_CIDADE';

  private NOTIFICACAO_PARA_UF = 'NOTIFICACAO_PARA_UF';

  // Dialog
  public dialogInterface = {
    formTitle: '',
    dialog: false,
    textBotaoPrimario: 'Salvar',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalCriarEditar,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Dialog Excluir Equipamento
  public dialogExcluirNotificacao = {
    formTitle: 'Excluir Notificação',
    dialog: false,
    textBotaoPrimario: 'Excluir',
    funcaoPrimaria() {
      //
    },
    fecharModal: this.fecharModalExcluir,
    colorBotaoPrimario: 'primary',
  } as BaseDialogInterface;

  // Campos do Dialog
  public readonlyCamposDialog = false;

  // Lista do data-table
  public lista: Array<NotificacaoInterface> = [];

  public headers: Array<Record<string, any>> = [

    {
      text: 'Título', align: 'center', sortable: false, value: 'titulo',
    },
    {
      text: 'Descrição', align: 'center', sortable: false, value: 'descricao',
    },
    {
      text: 'Ação', align: 'center', sortable: false, value: 'acao',
    },
  ];

  public listaCamposPesquisa = [
    {
      text: 'descrição',
      type: 'textField',
      value: 'descricao',
      cols: '6',
      itemText: 'descricao',
      items: this.getDDDs,
      clearable: true,
    },
    {
      text: 'Título',
      type: 'textField',
      value: 'titulo',
      cols: '6',
      itemText: 'titulo',
      clearable: true,
    },
    {
      text: 'DDD',
      type: 'selectField',
      value: 'ddd',
      cols: '2',
      itemText: 'ddd',
      items: this.getDDDs,
      clearable: true,
      searchable: true,
    },
    {
      text: 'Estado',
      type: 'selectField',
      value: 'uf',
      cols: '4',
      itemText: 'uf',
      items: this.getDDDs,
      clearable: true,
      searchable: true,
    },
    {
      text: 'Cidade',
      type: 'selectField',
      value: 'cidade',
      cols: '5',
      itemText: 'cidade',
      items: this.getDDDs,
      clearable: true,
      searchable: true,
    },
  ];

  public colapses = [
    { titulo: 'Filtragem', nomeSlot: 'pesquisa' },
    { titulo: 'Lista de Notificações', nomeSlot: 'lista' },
  ];

  public optionsTipoNotificacao: Array<object> = [
    {
      id: 'NOTIFICACAO_GERAL',
      label: 'Notificação Geral',
    },
    {
      id: 'NOTIFICACAO_PARA_CIDADE',
      label: 'Notificação para Cidade',
    },
    {
      id: 'NOTIFICACAO_PARA_UF',
      label: 'Notificação para Estado',
    },
  ];

  public optionsPeriodoNotificacao: Array<object> = [
    {
      id: 'NOTIFICACAO_DIARIA',
      label: 'Notificação Diária',
    },
    {
      id: 'NOTIFICACAO_SEMANAL',
      label: 'Notificação Semanal',
    },
    {
      id: 'NOTIFICACAO_MENSAL',
      label: 'Notificação Mensal',
    },
  ];

  public listaAcoes = [
    { tooltip: 'Editar', icon: 'mdi-square-edit-outline', function: this.abrirEditar },
    { tooltip: 'Excluir', icon: 'mdi-delete-outline', function: this.abrirExcluir },
    { tooltip: 'Enviar', icon: 'mdi-send', function: this.abrirExcluir },
  ];

  // Dialog de Editar
  private async abrirEditar(item: any) {
    this.dialogInterface.formTitle = 'Editar Notificação';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.readonlyCamposDialog = false;
    this.dialogInterface.funcaoPrimaria = this.salvarAtualizar;
    this.editedItem = item;
    if (this.editedItem.tipoNotificacao === this.NOTIFICACAO_PARA_CIDADE) {
      this.editedItem.cidades = this.editedItem.ddds.map((d) => d.cidade);
    } else if (this.editedItem.tipoNotificacao === this.NOTIFICACAO_PARA_UF) {
      this.editedItem.ufs = this.getUFs(this.editedItem.ddds.map((d) => d.uf));
    }
    if (this.editedItem !== undefined) {
      this.dialogInterface.dialog = true;
    }
    this.notificacaoRecorrente = this.defineInicialValue();
  }

  // Dialog de Criar
  public abrirCriar() {
    this.dialogInterface.formTitle = 'Nova Notificação';
    this.dialogInterface.textBotaoPrimario = 'Salvar';
    this.readonlyCamposDialog = false;
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.salvarAtualizar;
    this.editedItem = {} as NotificacaoInterface;
    this.dialogInterface.dialog = true;
  }

  // Dialog de Excluir
  private async abrirExcluir(item: any) {
    this.dialogExcluirNotificacao.formTitle = 'Excluir Notificação';
    this.dialogExcluirNotificacao.textBotaoPrimario = 'Excluir';
    this.dialogExcluirNotificacao.colorBotaoPrimario = 'warning';
    this.readonlyCamposDialog = true;
    this.dialogExcluirNotificacao.funcaoPrimaria = this.excluir;
    this.editedItem = item;
    if (this.editedItem !== undefined) {
      this.dialogExcluirNotificacao.dialog = true;
    }
  }

  // Dialog de Envio de Notificação.
  public abrirEnviar(item: any) {
    this.dialogInterface.formTitle = 'Enviar Notificação';
    this.dialogInterface.textBotaoPrimario = 'Enviar';
    this.readonlyCamposDialog = true;
    this.dialogInterface.colorBotaoPrimario = 'primary';
    this.dialogInterface.funcaoPrimaria = this.enviarNotificacao;
    this.editedItem = item;
    if (this.editedItem.tipoNotificacao === this.NOTIFICACAO_PARA_CIDADE) {
      this.editedItem.cidades = this.editedItem.ddds.map((d) => d.cidade);
    } else if (this.editedItem.tipoNotificacao === this.NOTIFICACAO_PARA_UF) {
      this.editedItem.ufs = this.getUFs(this.editedItem.ddds.map((d) => d.uf));
    }
    if (this.editedItem !== undefined) {
      this.dialogInterface.dialog = true;
    }
  }

  async buscarTodos() {
    this.lista = await new NotificacaoService().buscarTodos();
    this.loading = false;
  }

  public getDDDs() {
    return this.listaDDD;
  }

  public defineInicialValue() {
    this.notificacaoRecorrente = (
      this.editedItem.periodoNotificacao !== 'NOTIFICACAO_UNICA'
      && this.editedItem.periodoNotificacao !== null
      && this.editedItem.periodoNotificacao !== undefined);
    return this.notificacaoRecorrente;
  }

  public getUFs(ufs: string[]) {
    return [...new Set(ufs)];
  }

  async buscarDDDs() {
    const result = await new DDDService().buscarTodos();
    this.listaDDD = Object.assign([], result);
    this.listaCidades = Object.assign([], result.sort((a, b) => {
      const x = a.cidade.toLowerCase();
      const y = b.cidade.toLowerCase();
      if (x > y) {
        return 1;
      }
      if (x < y) {
        return -1;
      }
      return 0;
    }));

    this.listaEstados = Object.assign([], result.sort((a, b) => {
      const x = a.uf.toLowerCase();
      const y = b.uf.toLowerCase();
      if (x > y) {
        return 1;
      }
      if (x < y) {
        return -1;
      }
      return 0;
    }));
  }

  async salvarAtualizar() {
    if (this.editedItem.tipoNotificacao === 'NOTIFICACAO_PARA_CIDADE') {
      this.editedItem.ufs = [];
    } else if (this.editedItem.tipoNotificacao === 'NOTIFICACAO_PARA_UF') {
      this.editedItem.cidades = [];
    }

    new NotificacaoService().salvarAtualizar(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.buscarTodos();
      });
  }

  async pesquisar() {
    this.lista = await new NotificacaoService().buscarComFiltro(this.filtro);
  }

  async excluir() {
    new NotificacaoService().excluir(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.buscarTodos();
      });
  }

  private fecharModalExcluir() {
    this.dialogExcluirNotificacao.dialog = false;
    this.editedItem = {} as NotificacaoInterface;
  }

  async enviarNotificacao() {
    this.editedItem.status = 'ENVIADA';
    new NotificacaoService().enviarNotificacao(this.editedItem)
      .then(() => {
        this.fecharModalCriarEditar();
        this.buscarTodos();
      });
  }

  private fecharModalCriarEditar() {
    this.dialogInterface.dialog = false;
    this.editedItem = {} as NotificacaoInterface;
    this.notificacaoRecorrente = false;
    this.buscarTodos();
  }

  mounted() {
    this.buscarTodos();
    this.buscarDDDs();
  }
}
